module.exports = __webpack_public_path__ + "img/step5-en.8a0f8e9c.png";